module.exports = __webpack_public_path__ + "img/Screen4.2236e410.png";